import React from 'react';

import './styles.scss'

const BlankPage = ({ children }) => {
  return <div className='blank-page'>{children}</div>;
};

export default BlankPage;
